import React, { Component } from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup,
    StateStoring,
} from 'devextreme-react/data-grid';
import PaginaToolbar from '../../components/PaginaToolbar';
import { criarFatorCorretivoDs } from "../../DataSources";
import UserInfo from "../../UserInfo";
import uiInfo from "../../ui-info";

const localStorageKey = "cadastroFatoresCorretivosGridState";

let _fatorCorretivoCorrente = undefined;

export default class FatoresCorretivosBox extends Component {
    constructor() {
        super();
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("fatorescorretivos/editar/" + e.data.id);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Fatores Corretivos" novoCb={this.novoFatorCorretivo.bind(this)}>
                    <DataGrid
                        ref={grid => this._gridInstance = grid}
                        dataSource={criarFatorCorretivoDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        columnAutoWidth={true}
                        columnHidingEnabled={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={window.innerWidth < 800}
                        filterSyncEnabled={true}
                        onEditingStart={this.onAtualizandoRow}>
                        <StateStoring enabled={true} type={'localStorage'} storageKey={localStorageKey} />
                        <FilterRow visible={true} />
                        <Editing allowDeleting={true} allowUpdating={true} mode />
                        <Column dataField={'id'} caption={"#"} width={'50px'}/>
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'tipo'} caption={"Tipo"} />
                        <Column dataField={'variavel'} caption={"Variável"} />
                        <Column dataField={'descricao'} caption={"Descrição"} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    novoFatorCorretivo() {
        let gridState = this._gridInstance.instance.state();
        localStorage.setItem(localStorageKey, JSON.stringify(gridState));
        this.props.history.push("fatorescorretivos/novo");
    }

}
